import {
	IAppearanceForm,
	IExtremeSet,
	IExtremeSetNames,
	ISlidersPayload,
	ExtremeTypes,
} from '../models';

export enum GeneralSliderNames {
	firstSlider = 'firstSlider',
	secondSlider = 'secondSlider',
	thirdSlider = 'thirdSlider',
}

export const sliderNameTypes = [
	IExtremeSetNames.firstSliderName,
	IExtremeSetNames.secondSliderName,
	IExtremeSetNames.thirdSliderName,
];

const sliderTypes = {
	[GeneralSliderNames.firstSlider]: [
		IExtremeSetNames.firstMinExtreme,
		IExtremeSetNames.firstMaxExtreme,
	],
	[GeneralSliderNames.secondSlider]: [
		IExtremeSetNames.secondMinExtreme,
		IExtremeSetNames.secondMaxExtreme,
	],
	[GeneralSliderNames.thirdSlider]: [
		IExtremeSetNames.thirdMinExtreme,
		IExtremeSetNames.thirdMaxExtreme,
	],
};

export function parseExtremesToOptionList(extremeSetList: IExtremeSet[]) {
	return Object.entries(sliderTypes).reduce(
		(res: any, [type, names], index) => {
			const setData = extremeSetList.map((extremeSet: IExtremeSet) => {
				const keys = Object.keys(extremeSet).filter((key) =>
					names.includes(key as IExtremeSetNames),
				);

				const value = keys
					.map((key) => extremeSet[key as IExtremeSetNames])
					.join(' / ');

				return {
					title: value,
					value,
					sliderName: extremeSet[sliderNameTypes[index]],
				};
			});

			return {
				...res,
				[type]: setData,
			};
		},
		{},
	) as Record<string, { title: string; value: string; sliderName: string }[]>;
}

export const parseAppearanceFormDataToExtremes = (
	data: Partial<IAppearanceForm>,
	extremeType: ExtremeTypes,
	extremeSet?: IExtremeSet[],
) => {
	if (!data || !extremeSet) return;

	const payloadExtremeSet = Object.entries(sliderTypes).reduce(
		(res: any, [type, value]) => {
			const sliderNumberName = type[0].toUpperCase() + type.slice(1);
			const sliderName = `${extremeType}${sliderNumberName}`;

			return {
				...res,
				[(value as string[])[0]]: data[sliderName].split(' / ')[0],
				[(value as string[])[1]]: data[sliderName].split(' / ')[1],
			};
		},
		{},
	) as ISlidersPayload;

	Object.entries(sliderTypes).forEach(([sliderType, sliderExtremeNames]) => {
		const minExtremeName = sliderExtremeNames[0];
		const maxExtremeName = sliderExtremeNames[1];
		extremeSet.forEach((extreme) => {
			if (
				extreme[minExtremeName] === payloadExtremeSet[minExtremeName] &&
				extreme[maxExtremeName] === payloadExtremeSet[maxExtremeName]
			) {
				const sliderTypeName = (`${sliderType}Name` as unknown) as IExtremeSetNames;
				payloadExtremeSet[sliderTypeName] = extreme[sliderTypeName];
			}
		});
	});

	return payloadExtremeSet;
};
